import {
    Container,
    Row,
    Col,
    List
} from "reactstrap";
import styles from './styles.module.scss';
import Link from 'next/link';
import {
    TwitterShareButton,
    TwitterIcon,
    FacebookShareButton,
    FacebookIcon,
    WhatsappShareButton,
    WhatsappIcon,
    LinkedinShareButton,
    LinkedinIcon,
    EmailShareButton,
    EmailIcon,
} from 'next-share';
import Clipboard from '/public/site-assets/svg/clipboard.svg';
import React, { useState } from 'react';

export default function SocialShare({
    siteUrl = 'https://www.srgtalent.com',
    urlPrefix = 'jobs',
    customClass = "",
    post,
    body,
    twitter,
    facebook,
    linkedin,
    whatsapp,
    email,
    simplePageUrl = false,
    LinkCopy
}) {

    const [linkCopied, setLinkCopied] = useState(false);

    const copyToClipboard = () => {
        const currentURL = window.location.href;

        const textArea = document.createElement('textarea');
        textArea.value = currentURL;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);

        setLinkCopied(true);

        // Clear the "Link Copied" message after a few seconds
        setTimeout(() => {
            setLinkCopied(false);
        }, 2000);
    };
    return (
        <div className={`${styles.root} ${customClass}`}>
            <div className="social-links-wrapper">
                {twitter ?
                    <TwitterShareButton
                        url={`${siteUrl}${simplePageUrl ? "" : "/"}${urlPrefix}${post?.url_slug ? post?.url_slug : ""}`}
                        title={post?.title ? post?.title : post + ' | SRG'} >

                        <TwitterIcon size={42} round />
                    </TwitterShareButton>
                    : null}
                {facebook ?
                    <FacebookShareButton
                        url={`${siteUrl}${simplePageUrl ? "" : "/"}${urlPrefix}${post?.url_slug ? post?.url_slug : ""}`}
                        quote={post?.title ? post?.title : post + ' | SRG'} >

                        <FacebookIcon size={42} round />
                    </FacebookShareButton>
                    : null}
                {linkedin ?
                    <LinkedinShareButton
                        url={`${siteUrl}${simplePageUrl ? "" : "/"}${urlPrefix}${post?.url_slug ? post?.url_slug : ""}`} >

                        <LinkedinIcon size={42} round />
                    </LinkedinShareButton> : null}
                {whatsapp ?
                    <WhatsappShareButton
                        url={`${siteUrl}${simplePageUrl ? "" : "/"}${urlPrefix}${post?.url_slug ? post?.url_slug : ""}`}
                        title={post?.title ? post?.title : post + (post?.location ? ' | ' + post.location : " | " + 'SRG')}
                        separator=" " >

                        <WhatsappIcon size={42} round />
                    </WhatsappShareButton> : null
                }
                {email ?
                    <EmailShareButton
                        url={`${siteUrl}${simplePageUrl ? "" : "/"}${urlPrefix}${post?.url_slu ? post?.url_slug : ""}`}
                        subject={post?.title ? post?.title : post + (post?.location ? ' | ' + post.location : " | " + 'SRG')}
                        body={body} >

                        <EmailIcon size={42} round />
                    </EmailShareButton> : null}
                <div className="copy-link-button-container d-inline-block position-relative">
                    <button
                        aria-label="Copy Link"
                        className="custom-btn"
                        onClick={copyToClipboard}
                        disabled={linkCopied}
                    >
                        <Clipboard />
                    </button>
                    {linkCopied && (
                        <div className="tooltip">Link copied</div>
                    )}
                </div>
            </div>
        </div>
    )
}